import { render } from "./TabFilter.vue?vue&type=template&id=0a283fbe"
import script from "./TabFilter.vue?vue&type=script&lang=js"
export * from "./TabFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__